import GroupObject from "../objects/group"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import RectObject from "@/signomatic/app/objects/rect"

export default class CableLabelFixmethod extends BaseFixmethod {
  private get param() {
    return {
      holeWidth: Calc.mmToPx(4.5),
      holeHeight: Calc.mmToPx(2),
      holeRadius: Calc.mmToPx(0.2),
      distanceTop: this.drawables.sizeRelative("height", Calc.mmToPx(2), Calc.mmToPx(4), {
        minHeight: 10,
        maxHeight: 50,
      }),
      distanceLeft: this.drawables.sizeRelative("width", Calc.mmToPx(2), Calc.mmToPx(4), {
        minWidth: 25,
        maxWidth: 100,
      }),
    }
  }

  topDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const strokeWidth = 1 / this.drawables.scale

    const holeStroke = "#aaa"
    const holeFill = "#F5F7F6"

    items.push(
      new RectObject({
        fill: holeFill,
        stroke: holeStroke,
        strokeWidth: strokeWidth,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: this.param.holeWidth / 2 + this.param.distanceLeft - this.param.holeRadius,
        top: this.param.holeHeight / 2 + this.param.distanceTop - this.param.holeRadius,
      }).addClass("hang")
    )

    items.push(
      new RectObject({
        fill: holeFill,
        stroke: holeStroke,
        strokeWidth: strokeWidth,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: widthPx - this.param.holeWidth / 2 - this.param.distanceLeft + this.param.holeRadius,
        top: this.param.holeHeight / 2 + this.param.distanceTop - this.param.holeRadius,
      }).addClass("hang")
    )

    items.push(
      new RectObject({
        fill: holeFill,
        stroke: holeStroke,
        strokeWidth: strokeWidth,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: this.param.holeWidth / 2 + this.param.distanceLeft - this.param.holeRadius,
        top: heightPx - this.param.holeHeight / 2 - this.param.distanceTop + this.param.holeRadius,
      }).addClass("hang")
    )

    items.push(
      new RectObject({
        fill: holeFill,
        stroke: holeStroke,
        strokeWidth: strokeWidth,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: widthPx - this.param.holeWidth / 2 - this.param.distanceLeft + this.param.holeRadius,
        top: heightPx - this.param.holeHeight / 2 - this.param.distanceTop + this.param.holeRadius,
      }).addClass("hang")
    )

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
    ]
  }

  engravingDrawable() {
    const { widthPx, heightPx } = this.state
    const stroke = this.drawables.engravingColor
    const strokeWidth = this.drawables.engravingStrokeWidth
    const fill = "transparent"
    const items = []

    items.push(
      new RectObject({
        stroke,
        strokeWidth: strokeWidth,
        fill,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: this.param.holeWidth / 2 + this.param.distanceLeft - this.param.holeRadius,
        top: this.param.holeHeight / 2 + this.param.distanceTop - this.param.holeRadius,
      }).addClass("hang")
    )

    items.push(
      new RectObject({
        stroke,
        strokeWidth: strokeWidth,
        fill,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: widthPx - this.param.holeWidth / 2 - this.param.distanceLeft + this.param.holeRadius,
        top: this.param.holeHeight / 2 + this.param.distanceTop - this.param.holeRadius,
      }).addClass("hang")
    )

    items.push(
      new RectObject({
        stroke,
        strokeWidth: strokeWidth,
        fill,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: this.param.holeWidth / 2 + this.param.distanceLeft - this.param.holeRadius,
        top: heightPx - this.param.holeHeight / 2 - this.param.distanceTop + this.param.holeRadius,
      }).addClass("hang")
    )

    items.push(
      new RectObject({
        stroke,
        strokeWidth: strokeWidth,
        fill,
        rx: this.param.holeRadius,
        width: this.param.holeWidth,
        height: this.param.holeHeight,
        left: widthPx - this.param.holeWidth / 2 - this.param.distanceLeft + this.param.holeRadius,
        top: heightPx - this.param.holeHeight / 2 - this.param.distanceTop + this.param.holeRadius,
      }).addClass("hang")
    )

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
    ]
  }
}
